"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatesSelectionRange = void 0;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var react_date_range_1 = require("react-date-range");
var React = __importStar(require("react"));
var locale_1 = require("date-fns/locale");
var date_fns_1 = require("date-fns");
var dates_selection_navigator_1 = require("./dates-selection-navigator");
var dates_selection_footer_1 = require("./dates-selection-footer");
var format_date_1 = require("./format-date");
var use_did_update_effect_1 = require("./use-did-update-effect");
var mapDatesToDateRange = function (sd, ed) { return [
    {
        startDate: (0, date_fns_1.parseISO)(sd),
        endDate: (0, date_fns_1.parseISO)(ed),
        key: 'selection',
    },
]; };
var DatesSelectionRange = function (_a) {
    var dateSelection = _a.dateSelection, className = _a.className, wrapperClassName = _a.wrapperClassName, months = _a.months, direction = _a.direction, toggleDateChangeVisibility = _a.toggleDateChangeVisibility, seasons = _a.seasons, maxReservationDays = _a.maxReservationDays, minReservationDays = _a.minReservationDays, onDatesUpdated = _a.onDatesUpdated, dateFrom = _a.dateFrom, dateTo = _a.dateTo, getStayDeclination = _a.getStayDeclination;
    var _b = React.useState({ date_from: dateFrom, date_to: dateTo }), dates = _b[0], setDates = _b[1];
    var _c = React.useState(undefined), focusedDate = _c[0], setFocusedDate = _c[1];
    var _d = React.useState(mapDatesToDateRange(dateFrom, dateTo)), range = _d[0], setRange = _d[1];
    var _e = React.useState([]), inactiveDays = _e[0], setInactiveDays = _e[1];
    React.useEffect(function () {
        setRange(mapDatesToDateRange(dates.date_from, dates.date_to));
    }, [dates]);
    (0, use_did_update_effect_1.useDidUpdateEffect)(function () {
        onDatesUpdated(dates);
    }, [dates]);
    React.useEffect(function () {
        return function () {
            if (dateSelection.isPickingEndDate)
                dateSelection.onRangeFocusChange([0]);
        };
    }, [dateSelection.isPickingEndDate]);
    var isDayDisabled = function (date) {
        return !minReservationDays
            ? (0, date_fns_1.isBefore)(date, (0, date_fns_1.startOfToday)())
            : (0, date_fns_1.isBefore)(date, (0, date_fns_1.startOfToday)()) || inactiveDays.includes((0, format_date_1.formatDate)(date));
    };
    var handleDateChange = function (data) {
        changeData({ date_from: (0, format_date_1.formatDate)(data.selection.startDate), date_to: (0, format_date_1.formatDate)(data.selection.endDate) });
    };
    var daysDiff = function () { return (0, date_fns_1.differenceInDays)((0, date_fns_1.parseISO)(dates.date_to), (0, date_fns_1.parseISO)(dates.date_from)); };
    var changeData = function (data) {
        var _a;
        setDates(data);
        (_a = dateSelection.onDateChange) === null || _a === void 0 ? void 0 : _a.call(dateSelection, data);
        if (minReservationDays && minReservationDays !== 1) {
            var days = (0, date_fns_1.eachDayOfInterval)({
                start: (0, date_fns_1.addDays)((0, date_fns_1.parseISO)(data.date_from), 1),
                end: (0, date_fns_1.addDays)((0, date_fns_1.parseISO)(data.date_from), minReservationDays - 1),
            });
            setInactiveDays(days.map(function (date) { return (0, format_date_1.formatDate)(date); }));
        }
        if (inactiveDays.length && !(0, date_fns_1.isEqual)((0, format_date_1.parseISODate)(data.date_from), (0, format_date_1.parseISODate)(data.date_to))) {
            setInactiveDays([]);
        }
    };
    var navigatorRenderer = function (currentFocusedDate, changeShownDate) {
        var isYearActive = function (year) { return year === currentFocusedDate.getFullYear(); };
        return (React.createElement(dates_selection_navigator_1.DatesSelectionNavigator, { seasons: seasons, isYearActive: isYearActive, changeShownDate: changeShownDate, startingDate: dates.date_from, endingDate: dates.date_to, currentFocusedDate: currentFocusedDate, isPickingEndDate: dateSelection.isPickingEndDate, daysDiff: daysDiff(), months: months, focusedDate: focusedDate, setFocusedDate: setFocusedDate, stayDeclination: getStayDeclination(daysDiff()) }));
    };
    if (!dates)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "date-range ".concat(wrapperClassName || ''), role: "date-range" },
            React.createElement(react_date_range_1.DateRange, { dateDisplayFormat: "dd MMMM yyyy", locale: locale_1.pl, ranges: range, onChange: handleDateChange, className: className || '', navigatorRenderer: navigatorRenderer, onRangeFocusChange: dateSelection.onRangeFocusChange, weekdayDisplayFormat: "ccccc", rangeColors: ['#b99153'], disabledDay: isDayDisabled, months: months, direction: direction, maxDate: dateSelection.isPickingEndDate ? (0, date_fns_1.addDays)((0, format_date_1.parseISODate)(dates.date_from), maxReservationDays - 1) : undefined, minDate: dateSelection.isPickingEndDate ? (0, date_fns_1.addDays)((0, format_date_1.parseISODate)(dates.date_from), 1) : undefined })),
        React.createElement(dates_selection_footer_1.DatesSelectionFooter, { onClear: changeData, isPickingEndDate: dateSelection.isPickingEndDate, toggleDateChangeVisibility: toggleDateChangeVisibility, setFocusedDate: setFocusedDate, dateTo: dateTo, dateFrom: dateFrom })));
};
exports.DatesSelectionRange = DatesSelectionRange;
